



















































































































































































































































import Vue from 'vue'
import Organization from '../../../../store/models/Organization'
import api from '../../../../api'

export default Vue.extend({
  data() {
    return {
      loading: false,
      loadingCreditLines: false,
      stats: null as any,
      creditLines: [] as any[],
      searchPhone: '' as string,
      searchLoading: false,
      searchError: null as string | null,
      searchResult: null as any,
      creditLineColumns: [
        { label: 'Nom', field: 'name' },
        { label: 'Référence', field: 'reference' },
        { label: 'Date de création', field: 'createdAt' },
        { label: 'Montant alloué', field: 'allocatedAmount' },
        { label: 'Montant décaissé', field: 'disbursedAmount' },
        { label: 'Montant restant', field: 'remainingAmount' },
        { label: 'Dispatchings', field: 'dispatchingsCount' },
        { label: 'État', field: 'state' },
        { label: 'Actions', field: '_actions' }
      ],
      creditLinePage: 1,
      creditLineLimit: 10,
      creditLineTotal: 0,
      creditLineTotalPages: 0
    }
  },

  computed: {
    sfdId(): string {
      return this.$route.params.sfdId
    },

    sfd(): any {
      return Organization.find(this.sfdId)
    }
  },

  methods: {
    formatAmount(amount: number): string {
      return new Intl.NumberFormat('fr-FR').format(amount || 0)
    },

    formatDate(date: string): string {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    getCacheKey(key: string): string {
      return `sfd_${this.sfdId}_${key}`
    },

    loadFromCache(key: string): any {
      try {
        const cached = localStorage.getItem(this.getCacheKey(key))
        if (cached) {
          const data = JSON.parse(cached)
          const expiryTime = 5 * 60 * 1000
          if (Date.now() - data.timestamp < expiryTime) {
            return data.value
          }
        }
      } catch (error) {
        console.error('Error loading from cache:', error)
      }
      return null
    },

    saveToCache(key: string, value: any): void {
      try {
        localStorage.setItem(
          this.getCacheKey(key),
          JSON.stringify({
            value,
            timestamp: Date.now()
          })
        )
      } catch (error) {
        console.error('Error saving to cache:', error)
      }
    },

    async loadStats() {
      const cachedStats = this.loadFromCache('stats')
      if (cachedStats) {
        this.stats = cachedStats
      }

      this.loading = true
      try {
        const response = await api.get(`/organizations/${this.sfdId}/stats`)
        this.stats = response.data
        this.saveToCache('stats', response.data)
      } catch (error) {
        console.error('Error loading stats:', error)
        this.$notify.error('Erreur lors du chargement des statistiques')
      } finally {
        this.loading = false
      }
    },

    async loadCreditLines() {
      const cacheKey = `creditLines_page${this.creditLinePage}`
      const cachedData = this.loadFromCache(cacheKey)
      if (cachedData) {
        this.creditLines = cachedData.data.map((cl: any) => ({
          ...cl,
          createdAt: this.formatDate(cl.createdAt)
        }))
        this.creditLineTotal = cachedData.total
        this.creditLineTotalPages = cachedData.totalPages
      }

      this.loadingCreditLines = true
      try {
        const response = await api.get(
          `/credit-lines/organization/${this.sfdId}/with-stats`,
          {
            params: {
              page: this.creditLinePage,
              limit: this.creditLineLimit
            }
          }
        )
        this.creditLines = response.data.data.map((cl: any) => ({
          ...cl,
          createdAt: this.formatDate(cl.createdAt)
        }))
        this.creditLineTotal = response.data.total
        this.creditLineTotalPages = response.data.totalPages
        this.saveToCache(cacheKey, response.data)
      } catch (error) {
        console.error('Error loading credit lines:', error)
        this.$notify.error('Erreur lors du chargement des lignes de crédit')
      } finally {
        this.loadingCreditLines = false
      }
    },

    async changeCreditLinePage(page: number) {
      if (page < 1 || page > this.creditLineTotalPages) return
      this.creditLinePage = page
      await this.loadCreditLines()
    },

    viewDispatchings(creditLineId: string) {
      this.$router.push({
        name: 'sfds.creditline.dispatchings',
        params: {
          sfdId: this.sfdId,
          creditLineId
        }
      })
    },

    async searchBeneficiary() {
      if (!this.searchPhone.trim()) {
        return
      }

      this.searchLoading = true
      this.searchError = null
      this.searchResult = null

      try {
        const response = await api.get(
          `/beneficiaries/search-by-phone/${this.searchPhone.trim()}`
        )
        this.searchResult = response.data
      } catch (error) {
        console.error('Error searching beneficiary:', error)
        this.searchError =
          error.response?.data?.message ||
          'Bénéficiaire non trouvé ou erreur lors de la recherche'
      } finally {
        this.searchLoading = false
      }
    },

    viewBeneficiaryDetails() {
      if (this.searchResult && this.searchResult.id) {
        this.$router.push({
          name: 'fnm.beneficiary-details',
          params: { beneficiaryId: this.searchResult.id }
        })
      }
    }
  },

  async created() {
    await Organization.api().find(this.sfdId)

    if (this.sfd && this.sfd.name) {
      try {
        localStorage.setItem(`sfd_${this.sfdId}_name`, this.sfd.name)
      } catch (error) {
        console.error('Error saving SFD name to cache:', error)
      }
    }

    await Promise.all([this.loadStats(), this.loadCreditLines()])
  }
})
